// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2t_t1","disabled":"styles_disabled__2EEyd"};